import React from 'react';
import { Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import Typography from 'style-guide/component/Typography';
import { QuestionFileUploadProps } from '../types/questionTypes';

const QuestionFileUpload: React.FC<QuestionFileUploadProps> = ({
  currentFileList,
  beforeUpload,
  handleFilesChange,
  fileTypeError,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <Typography variant="Base" strong text="Attach files (optional)" />
        {currentFileList.length > 0 && (
          <Typography 
            variant="XS" 
            text={`${currentFileList.length} file(s) attached`}
            className="text-gray-500"
          />
        )}
      </div>
      
      <div>
        <Typography
          text="You can upload files in PDF, DOC, DOCX, CSV, XLS, or XLSX formats. Files will be automatically prefixed with the question number (e.g., Q1_filename.pdf)."
          variant="Base"
          className="text-[#00000099]"
        />
      </div>
      
      <Upload.Dragger
        fileList={currentFileList}
        beforeUpload={beforeUpload}
        onChange={handleFilesChange}
        showUploadList={false}
        multiple
        customRequest={({ onSuccess }) => setTimeout(() => onSuccess && onSuccess("ok"), 0)}
        accept=".pdf,.doc,.docx,.csv,.xls,.xlsx"
        className="w-full h-[20vh]"
      >
        <Typography variant="Base" className="ant-upload-drag-icon">
          <InboxOutlined style={{ fontSize: 50, color: "#0F428D" }} />
        </Typography>
        <Typography
          variant="Heading 5"
          className="mt-1"
          text="PDF, Documents (DOC/DOCX), Spreadsheets (XLS/XLSX)"
        />
        <Typography variant="Heading 5" text="Max file size: 25MB" className="mt-1"/>
      </Upload.Dragger>
      
      {fileTypeError && (
        <div className="text-red-500 mt-2">{fileTypeError}</div>
      )}
    </div>
  );
};

export default QuestionFileUpload;
